import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { message, PageHeader, Tooltip } from "antd";
import {
  EditOutlined,
  FileExcelOutlined,
} from "@ant-design/icons";
import ButtonItem from "../../../Components/ButtonItem";
import TableItem from "../../../Components/TableItem";
import AgregarUnidad from "../Insumos/AgregarInsumo/AgregarUnidad/AgregarUnidad";

class Unidades extends Component {
  state = {
    todasUnidades: [],
    modalUnidad: false,
    unidadEditarId: null,
    loading: false,
  };

  componentDidMount() {
    this.consultarUnidades();
  }

  consultarUnidades() {
    this.setState({ loading: true });
    axios
      .post(
        "unidades/selectTodasUnidades",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.status !== 404) {
          this.setState({
            todasUnidades: res.data.map((value) => {
              return {
                ...value,
                accion: { _id: value._id, estado: value.estado },
              };
            }),
          });
        }
      });
  }

  deshabilitarUnidad(id) {
    axios
      .post(
        "unidades/deshabilitarUnidad",
        { unidadId: id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Unidad deshabilitada");
        } else {
          message.error("Sucedió un error y no se pudo deshabilitar");
        }
        this.consultarUnidades();
      });
  }

  abrirModalUnidad(id = null) {
    this.setState({ modalUnidad: true, unidadEditarId: id });
  }

  cerrarModalUnidad() {
    this.setState({ modalUnidad: false, unidadEditarId: null });
    this.consultarUnidades();
  }

  render() {
    const columns = [
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        sorter: (a, b) => a.nombre.localeCompare(b.nombre),
        buscar: "nombre",
      },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
        sorter: (a, b) =>
          (a.descripcion || "").localeCompare(b.descripcion || ""),
        buscar: "descripcion",
      },
      {
        title: "Unidad SAT",
        dataIndex: "unidadSat",
        key: "unidad",
        sorter: (a, b) =>
          (a.descripcion || "").localeCompare(b.descripcion || ""),
        render: (value) => {
          return value.nombre + " - " + value.c_ClaveUnidad;
        },
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        onHeaderCell: () => ({
          style: { textAlign: "center", padding: "4px" },
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: "center", padding: "4px" },
        }),
        render: (value, index) => {
          let buttons = [];

          // Botón Editar
          if (this.props.permisoEditarUnidades) {
            buttons.push(
              <Tooltip
                title="Editar Unidad"
                placement="top"
                overlayInnerStyle={{
                  fontSize: "10px",
                  padding: "1px 5px",
                  minHeight: "auto",
                }}
                key={`edit-${index}`}
              >
                <ButtonItem
                  type="default"
                  size="small"
                  cyan
                  icon={<EditOutlined />}
                  onClick={() => this.abrirModalUnidad(value._id)}
                />
              </Tooltip>,
            );
          }

          return (
            <div
              className="acciones-container"
              style={{ display: "flex", gap: "8px", justifyContent: "center" }}
            >
              {buttons}
            </div>
          );
        },
      },
    ];

    return (
      <>
        <PageHeader
          title="Unidades de Insumos"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            this.props.permisoAgregarUnidades && (
              <>
                <ButtonItem
                  type="default"
                  key="importarUnidades"
                  verde
                  icon={<FileExcelOutlined />}
                  onClick={() => this.props.history.push('/panel/importarUnidades')}
                  className="botonAgregar"
                >
                  Importar Unidades
                </ButtonItem>
                <ButtonItem
                  type="primary"
                  key="agregarUnidadInsumo"
                  olivo
                  onClick={() => this.abrirModalUnidad()} // Sin ID = Agregar
                   className="botonAgregar"
                >
                  Agregar Unidad
                </ButtonItem>
              </>
            )
          }
        />

        <TableItem
          loading={this.state.loading}
          size="small"
          dataSource={this.state.todasUnidades}
          columns={columns}
          onRow={(record) => ({
            onDoubleClick: () => this.abrirModalUnidad(record._id),
          })}
        />
        <AgregarUnidad
          visible={this.state.modalUnidad}
          id={this.state.unidadEditarId}
          cerrarAgregarUnidad={this.cerrarModalUnidad.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoEditarUnidades:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "698f5f67668f5467a18e72fb",
      )?.activado,
    permisoAgregarUnidades:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "698f5f56668f5467a18e72fa",
      )?.activado,
  };
};

export default connect(mapStateToProps)(Unidades);
